import styled from 'styled-components';

export const DropdownMenu = styled.div`
  position: fixed;
  top: ${({ $top }) => ($top != null ? `${$top}px` : 'auto')};
  left: ${({ $left }) => ($left != null ? `${$left}px` : 'auto')};
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 4px;
  min-width: 180px;
  z-index: 10001;
  border: 1px solid #c9cbcf;
  max-height: 200px;
  overflow-y: auto;
  white-space: nowrap;
  will-change: transform;
`;

export const DropdownMenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  border-radius: 4px;
  font-family: 'Montserrat Regular', sans-serif;
  font-size: 14px;
  color: #0c0d0d;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ $disabled }) => ($disabled ? 'transparent' : '#f2f2f3')};
  }
`;

export const MenuIconWrap = styled.span`
  display: inline-flex;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: #797e86;
`;
